import initialState from './initialState';
import {
  FETCH_DSA_CONFIG,
  FETCH_DSA_CONFIG_SUCCESS,
  FETCH_DSA_CONFIG_FAILURE
} from '../constants/actionTypes';

// Assessment Config (/api/v1/dsa/config)

export default function dsaConfigReducer(state = initialState.dsaConfig, action) {

  // defaults
  let loading = false, error = null;

  switch (action.type) {

    case FETCH_DSA_CONFIG:
      loading = true;
      return {...state, error, loading};

    case FETCH_DSA_CONFIG_FAILURE:
      error = action.error || 'Error Loading Assessment Config';
      return {...state, error, loading};

    case FETCH_DSA_CONFIG_SUCCESS:

      action.data.areas = action.data.areas.sort( (a, b) => a.order - b.order );
      action.data.subAreas = action.data.subAreas.sort( (a, b) => a.order - b.order );
      action.data.useQuestions = action.data.useQuestions.sort( (a, b) => a.order - b.order );
      action.data.configuredItems = action.data.configuredItems.sort( (a, b) => a.order - b.order );
      action.data.goals = action.data.goals.sort( (a, b) => a.order - b.order );
      action.data.valueRealized = action.data.valueRealized.sort( (a, b) => a.order - b.order );
      action.data.analysisGoals = action.data.analysisGoals.sort( (a, b) => a.order - b.order );





      return {...action.data, error, loading};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dsaConfigReducer.js